import { lazy, Suspense } from 'react';

import type { PositionPlanProgressBlock } from '../../data-contract/chat';
import type { BlockRenderer } from './types';

// Loaded on demand: the position management barrel builds its tiles from the url tile modules,
// which load the chat themselves, so a static import would close that cycle while it initialises.
const PositionPlanProgressCard = lazy(async () => {
    const { PositionPlanProgressCard } = await import('./PositionPlanProgressCard');

    return { default: PositionPlanProgressCard };
});

export const positionPlanProgressBlockRenderer: BlockRenderer<PositionPlanProgressBlock> = {
    isAnswered: () => true,
    renderInline: (block) => (
        <Suspense fallback={null}>
            <PositionPlanProgressCard block={block} />
        </Suspense>
    ),
    rendersInlineContent: () => true,
    type: 'position-plan-progress',
};
